<template>
  <component :is="pageRoot">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row v-if="embedded" :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item :label="$t('views.specialMinimum.column.specOptionName')">
                <a-select
                  v-model="queryParam.specOptionId"
                  allow-clear
                  show-search
                  :placeholder="$t('views.specialMinimum.search.specOptionSelectPlaceholder')"
                  :loading="specOptionLoading"
                  option-filter-prop="_label"
                  option-label-prop="_label"
                  :filter-option="filterSpecOptionOption"
                  style="width: 100%"
                  :getPopupContainer="trigger => trigger.parentNode"
                  @dropdownVisibleChange="onSpecOptionDropdownVisible"
                >
                  <a-select-option
                    v-for="opt in specOptionOptions"
                    :key="opt.id"
                    :value="String(opt.id)"
                    :_label="opt.name"
                  >
                    {{ opt.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.specialMinimum.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.specialMinimum.btn.reset') }}</a-button>
              </span>
            </a-col>
          </a-row>
          <a-row v-else :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.specialMinimum.search.printMultiplesId')" prop="printMultiplesId">
                <a-input
                  v-model="queryParam.printMultiplesId"
                  :placeholder="$t('views.specialMinimum.search.printMultiplesIdPlaceholder')"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.specialMinimum.column.specOptionName')" prop="specOptionId">
                <a-select
                  v-model="queryParam.specOptionId"
                  allow-clear
                  show-search
                  :placeholder="$t('views.specialMinimum.search.specOptionSelectPlaceholder')"
                  :loading="specOptionLoading"
                  option-filter-prop="_label"
                  option-label-prop="_label"
                  :filter-option="filterSpecOptionOption"
                  style="width: 100%"
                  :getPopupContainer="trigger => trigger.parentNode"
                  @dropdownVisibleChange="onSpecOptionDropdownVisible"
                >
                  <a-select-option
                    v-for="opt in specOptionOptions"
                    :key="opt.id"
                    :value="String(opt.id)"
                    :_label="opt.name"
                  >
                    {{ opt.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.specialMinimum.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.specialMinimum.btn.reset') }}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('views.specialMinimum.btn.collapse') : $t('views.specialMinimum.btn.expand') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
          <a-row v-if="!embedded && advanced" :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.specialMinimum.search.price')" prop="price">
                <a-input v-model="queryParam.price" :placeholder="$t('views.specialMinimum.search.pricePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:specialMinimum:add']">
          <a-icon type="plus" />{{ $t('views.specialMinimum.btn.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:specialMinimum:edit']">
          <a-icon type="edit" />{{ $t('views.specialMinimum.btn.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:specialMinimum:remove']">
          <a-icon type="delete" />{{ $t('views.specialMinimum.btn.delete') }}
        </a-button>
       
      </div>
      <create-form
        ref="createForm"
        :default-print-multiples-id="effectiveFixedPrintMultiplesId"
        @ok="getList"
      />
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <!-- 表格排序列已注释
        <span slot="sort" slot-scope="text, record">
          <a-input-number
            :value="record.sort"
            :min="0"
            style="width: 100px"
            @change="(value) => handleSortChange(record, value, 'sort')"
          />
        </span>
        -->
        <span slot="specOptionName" slot-scope="text, record">
          {{ text || record.specOptionId || '-' }}
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status == 1 || record.status == '1'"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['user:specialMinimum:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:specialMinimum:edit']">
            <a-icon type="edit" />{{ $t('views.specialMinimum.btn.edit') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['user:specialMinimum:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['user:specialMinimum:remove']">
            <a-icon type="delete" />{{ $t('views.specialMinimum.btn.delete') }}
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </component>
</template>

<script>
import { pageSpecialMinimum, delSpecialMinimum, updateSpecialMinimum } from '@/api/user/specialMinimum'
import { listSpecOption } from '@/api/user/specOption'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

/** 与 CreateForm 中规格选项下拉数据源一致 */
const SPECIAL_MINIMUM_SPEC_OPTION_SPEC_ID = '647454949810278400'

export default {
  name: 'SpecialMinimum',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  props: {
    fixedPrintMultiplesId: {
      type: [Number, String],
      default: null
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        printMultiplesId: null,
        specOptionId: null,
        price: null,
        sort: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [],
      specOptionOptions: [],
      specOptionLoading: false
    }
  },
  computed: {
    pageRoot () {
      return this.embedded ? 'div' : 'page-header-wrapper'
    },
    effectiveFixedPrintMultiplesId () {
      const v = this.fixedPrintMultiplesId
      if (v === null || v === undefined || v === '') {
        return null
      }
      return v
    }
  },
  watch: {
    embedded () {
      this.buildColumns()
    },
    '$i18n.locale' () {
      this.buildColumns()
    },
    fixedPrintMultiplesId: {
      handler () {
        this.syncFixedPrintMultiplesFilter()
      },
      immediate: true
    }
  },
  created () {
    this.buildColumns()
    this.loadSpecOptionOptions()
  },
  methods: {
    loadSpecOptionOptions () {
      if (this.specOptionLoading) {
        return
      }
      this.specOptionLoading = true
      listSpecOption({ specId: SPECIAL_MINIMUM_SPEC_OPTION_SPEC_ID, parentId: 0 }).then(res => {
        const data = (res && res.data) || []
        this.specOptionOptions = Array.isArray(data) ? data : []
      }).finally(() => {
        this.specOptionLoading = false
      })
    },
    onSpecOptionDropdownVisible (open) {
      if (open && !this.specOptionOptions.length && !this.specOptionLoading) {
        this.loadSpecOptionOptions()
      }
    },
    filterSpecOptionOption (input, option) {
      const text =
        option &&
        option.componentOptions &&
        option.componentOptions.children &&
        option.componentOptions.children[0] &&
        option.componentOptions.children[0].text
      return (text || '').toLowerCase().includes((input || '').toLowerCase())
    },
    buildColumns () {
      const t = k => this.$t(k)
      const cols = [
        { title: t('views.specialMinimum.column.id'), dataIndex: 'id', ellipsis: true, align: 'center' },
        { title: t('views.specialMinimum.column.printMultiplesId'), dataIndex: 'printMultiplesId', ellipsis: true, align: 'center' },
        { title: t('views.specialMinimum.column.specOptionName'), dataIndex: 'specOptionName', scopedSlots: { customRender: 'specOptionName' }, ellipsis: true, align: 'center' },
        { title: t('views.specialMinimum.column.price'), dataIndex: 'price', ellipsis: true, align: 'center' },
        { title: t('views.specialMinimum.column.status'), dataIndex: 'status', scopedSlots: { customRender: 'status' }, ellipsis: true, align: 'center' },
        { title: t('views.specialMinimum.column.createTime'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, ellipsis: true, align: 'center' },
        { title: t('views.specialMinimum.column.operation'), dataIndex: 'operation', width: 200, fixed: 'right', scopedSlots: { customRender: 'operation' }, align: 'center' }
      ]
      if (this.embedded) {
        this.columns = cols.filter(c => c.dataIndex !== 'printMultiplesId')
      } else {
        this.columns = cols
      }
    },
    paginationShowTotal (total) {
      return this.$t('views.specialMinimum.pagination.total', { total })
    },
    syncFixedPrintMultiplesFilter () {
      const fixed = this.effectiveFixedPrintMultiplesId
      if (fixed != null && fixed !== '') {
        this.queryParam.printMultiplesId = fixed
      } else if (this.embedded) {
        this.queryParam.printMultiplesId = null
      }
      this.queryParam.pageNum = 1
      this.getList()
    },
    getList () {
      this.loading = true
      pageSpecialMinimum(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      const fixed = this.effectiveFixedPrintMultiplesId
      this.queryParam = {
        printMultiplesId: (this.embedded && fixed != null && fixed !== '') ? fixed : undefined,
        specOptionId: undefined,
        price: undefined,
        sort: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleDelete (row) {
      const that = this
      const ids = row.id || this.ids
      const idsText = Array.isArray(ids) ? ids.join(',') : String(ids)
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('views.specialMinimum.confirm.deleteTitle'),
        content: this.$t('views.specialMinimum.confirm.deleteContent', { ids: idsText }),
        onOk () {
          const data = []
          that.ids.map(id => data.push({ id: id }))
          return delSpecialMinimum(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(that.$t('views.specialMinimum.msg.deleteSuccess'), 3)
            })
        },
        onCancel () {
          that.ids = []
        }
      })
    },
    handleStatusChange (record, checked) {
      const statusValue = checked ? 1 : 0
      const updateData = {
        id: record.id,
        status: statusValue
      }
      updateSpecialMinimum(updateData).then(() => {
        record.status = statusValue
        this.$message.success(this.$t('views.specialMinimum.msg.statusOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.specialMinimum.msg.statusFail'))
      })
    }
  }
}
</script>
